import getTokenFingerprint from '@/utils/tokenFingerprint'

export const formDefaultState = () => ({
  name: null,
  selectedProducts: [],
  greetingMessage: {
    title: 'Hi @first_name',
    content: null,
    footer: null,
    logo: null,
  },
  displayName: null,
  isActive: true,
  tags: [],
  advancedOptions: {
    expirationDays: 90,
    allowExchange: false,
    disableThankYouNotes: false,
    disableReminderEmails: false,
    disableAlternativeGifts: true,
    emailSubjectLine: null,
    emailBodyText: null,
    giftGiverEmail: null,
    mainButtonLabel: null,
    cover: null,
    shipping: 'us_only',
    videoGreeting: null,
    successButton: {
      addButton: false,
      buttonURL: null,
      buttonLabel: null
    }
  },
})

const getFormDefaultState = () => {
  try {
    const fingerprint = getTokenFingerprint()
    if (!fingerprint) return formDefaultState()

    const saved = JSON.parse(localStorage.getItem('createCampaignData'))
    if (!saved || saved.tokenFingerprint !== fingerprint) return formDefaultState()

    // Merge onto current defaults so a draft saved before new fields were added
    // (e.g. a new advancedOptions field) doesn't end up with them `undefined`.
    const defaults = formDefaultState()

    return {
      ...defaults,
      ...saved.data,
      greetingMessage: { ...defaults.greetingMessage, ...saved.data.greetingMessage },
      advancedOptions: {
        ...defaults.advancedOptions,
        ...saved.data.advancedOptions,
        successButton: {
          ...defaults.advancedOptions.successButton,
          ...saved.data.advancedOptions?.successButton,
        },
      },
    }
  } catch {
    return formDefaultState()
  }
}

export default getFormDefaultState
